export default __webpack_public_path__ + "static/media/Background.94efc162.jpg";